import type { SxProps, Theme } from '@mui/material';

export const styles = {
    dialog: { '& .MuiPaper-root': { borderRadius: '16px' } } as SxProps<Theme>,
    title: {
        textAlign: 'center',
        fontSize: '20px',
        fontWeight: 500,
        color: 'grey.900',
    } as SxProps<Theme>,
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
        py: 1,
    } as SxProps<Theme>,
    actions: {
        display: 'flex',
        justifyContent: 'center',
        py: 1,
    } as SxProps<Theme>,
    submitBtn: (theme: Theme): SxProps<Theme> => ({
        backgroundColor: theme.palette.blue[700],
        color: theme.palette.white,
        py: 1.25,
        width: '60%',
        textTransform: 'none',
        '&:hover': { backgroundColor: theme.palette.blue[800] },
    }),
};
